import {
  RegExpMatcher,
  TextCensor,
  englishDataset,
  englishRecommendedTransformers,
} from 'obscenity';

/**
 * Shared profanity filtering for every player-authored name that can reach
 * another player's screen (astronaut name, song name, planet claim name).
 *
 * Two modes:
 *  - `hasProfanity` — gate local inputs: reject and let the player retype.
 *  - `censorName`   — sanitize remote strings we can't reject (other
 *    travelers' names/songs loaded from Firebase) by starring them out.
 */
const matcher = new RegExpMatcher({
  ...englishDataset.build(),
  ...englishRecommendedTransformers,
});

const censor = new TextCensor();

/** True if the text contains profanity (including l33t/spacing evasion). */
export function hasProfanity(text) {
  return !!text && matcher.hasMatch(text);
}

/** Replace any profane spans with asterisks; safe on null/empty input. */
export function censorName(text) {
  if (!text || !matcher.hasMatch(text)) return text;
  return censor.applyTo(text, matcher.getAllMatches(text));
}
